import React, { useEffect, useState } from 'react';
import './ItemModal.css';

const ItemModal = ({ item, onClose, onPurchase, isProcessing, feedback, position }) => {
  const [modalStyle, setModalStyle] = useState({});

  useEffect(() => {
    if (position) {
      const { top } = position;
      const maxTop = window.innerHeight - 100;
      const adjustedTop = top > maxTop ? maxTop : top;

      setModalStyle({
        top: `${adjustedTop}px`,
        transform: 'translate(-50%, 0)',
      });
    } else {
      setModalStyle({
        top: '10%',
      });
    }
  }, [position]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        style={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="close-button" onClick={onClose}>&times;</span>
        <div className="modal-header">
          <img src={item.imageUrl} alt={item.name} className="modal-item-image" />
          <div className="modal-item-info">
            <h2>{item.name}</h2>
            <p>Price: {item.currency === 'money' ? '💴' : '🪙'} {item.price}</p>
          </div>
        </div>
        <p className="modal-description">{item.description}</p>
        <button
          onClick={() => onPurchase(item)}
          disabled={isProcessing}
          className="modal-buy-button"
        >
          {isProcessing && feedback?.itemId === item.id ? 'Processing...' : 'Buy'}
        </button>
        {feedback && feedback.itemId === item.id && (
          <div className={`modal-feedback ${feedback.type}`}>
            {feedback.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemModal;
